import { css } from '@emotion/css';
import styled from 'styled-components';

export const LoginRegisterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const icon = css`
  max-width: 185px;
  margin-bottom: 78px;
`;

export const buttonSubmit = css`
  color: 'white';
  width: 328px;
  margin-top: 32px;
`;
